const sentSound = new Audio('/sounds/sent.mp3');
const receivedSound = new Audio('/sounds/received.mp3');

export const playSentSound = () => {
    sentSound.currentTime = 0; // Reset to start
    sentSound.play().catch(e => console.log("🔇 Audio play blocked by browser"));
};

export const playReceivedSound = () => {
    receivedSound.currentTime = 0;
    receivedSound.play().catch(e => console.log("🔇 Audio play blocked by browser"));
};